import React, { useEffect, useState } from 'react'
import './Products.css'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import ProductHeader from './page/ProductHeader'
import ProductShow from './page/ProductShow'
import { fetchProductsAPI } from '../../redux/reducers/productReducers'
import { RootState, useAppDispatch, useAppSelector } from '../../store'
import { fetchAllCategories } from '../../redux/reducers/categoryReducers'

function ProductPage() {
  const dispatch = useAppDispatch()
  const [ openFilter, setOpenFiler ] = useState(false)
  const products = useAppSelector((state: RootState) => state.products)
  const categories = useAppSelector((state: RootState) => state.categories)
  const setFilterOpen = React.useCallback(() => { setOpenFiler(!openFilter) }, [ openFilter ])
  const setFilterCLickOverlay = React.useCallback(() => { setOpenFiler(!openFilter) }, [ openFilter ])

  useEffect(() => {
    dispatch(fetchAllCategories())
    dispatch(fetchProductsAPI())
  }, [ dispatch ])
  return (
    <div className="main">
      <Header />
      <ProductHeader />
      <div className="productGreeting"><div className="p-title"> Products </div>
        <button onClick={setFilterOpen}>Filter</button>
      </div>
      <ProductShow setFilterCLickOverlay={setFilterCLickOverlay} openFilter={openFilter} categories={categories.allCates} products={products.allProducts} />
      <Footer />
    </div>
  )
}

export default React.memo(ProductPage)
